import { Component, OnInit } from "@angular/core";
import { MarketingCard } from "@rubbl-marketing";

@Component({
  selector: "app-list-your-machines-manage",
  templateUrl: "./list-your-machines-manage.component.html",
  styleUrls: ["./list-your-machines-manage.component.scss"],
})
export class ListYourMachinesManageComponent implements OnInit {
  baseImagePath: string;
  marketingCards: MarketingCard[];

  constructor() {}

  ngOnInit() {
    this.marketingCards = [
      {
        iconClass: "icon-switch text-dark",
        title: "Manage listings",
        body: "Easily manage the availability of your gear by making machines available or unavailable in a single click.",
      },
      {
        iconClass: "icon-tag text-dark",
        title: "Set your rates",
        body: "Maintain control over what you earn by setting your own rental rates using our market data as a guide.",
      },
      {
        iconClass: "icon-crosshair text-dark",
        title: "Track your gear",
        body: "Know exactly where your machines are at all times with our transparent order and machine tracking.",
      },
    ];
  }
}
